<template>
  <input
    :data-value="valueFormatted"
    type="date"
    class="pickadate"
    @click="openPicker"
  >
</template>

<script>
import ValidationMessageList from '../ValidationMessageList'
import $ from 'jquery'
import '../../../../vendor/xc-website/static/bower_components/pickadate/lib/picker.date'
import { formatDisplayDate } from '../../../utils/date'

export default {
  name: 'DatePickerField',
  components: {
    ValidationMessageList
  },
  props: {
    value: {
      type: Date,
      default: null
    }
  },
  computed: {
    valueFormatted: function () {
      return formatDisplayDate(this.value)
    }
  },
  mounted () {
    this.picker = $(this.$el).pickadate({
      klass: {
        picker: 'picker picker--date',
        frame: 'picker__frame date-frame'
      },
      monthsFull: [
        this.$t('datepicker.months.january'),
        this.$t('datepicker.months.february'),
        this.$t('datepicker.months.march'),
        this.$t('datepicker.months.april'),
        this.$t('datepicker.months.may'),
        this.$t('datepicker.months.june'),
        this.$t('datepicker.months.july'),
        this.$t('datepicker.months.august'),
        this.$t('datepicker.months.september'),
        this.$t('datepicker.months.october'),
        this.$t('datepicker.months.november'),
        this.$t('datepicker.months.december')
      ],
      weekdaysFull: [
        this.$t('datepicker.weekdays.full.sunday'),
        this.$t('datepicker.weekdays.full.monday'),
        this.$t('datepicker.weekdays.full.tuesday'),
        this.$t('datepicker.weekdays.full.wednesday'),
        this.$t('datepicker.weekdays.full.thursday'),
        this.$t('datepicker.weekdays.full.friday'),
        this.$t('datepicker.weekdays.full.saturday')
      ],
      weekdaysShort: [
        this.$t('datepicker.weekdays.short.sunday'),
        this.$t('datepicker.weekdays.short.monday'),
        this.$t('datepicker.weekdays.short.tuesday'),
        this.$t('datepicker.weekdays.short.wednesday'),
        this.$t('datepicker.weekdays.short.thursday'),
        this.$t('datepicker.weekdays.short.friday'),
        this.$t('datepicker.weekdays.short.saturday')
      ],
      container: '#main',
      today: this.$t('datepicker.today'),
      close: false,
      clear: this.$t('datepicker.clear'),
      firstDay: 0,
      editable: false,
      format: 'dd-mm-yyyy',
      closeOnClear: true,
      selected: 'picker__day--selected',
      focused: 'picker--focused',
      now: 'picker__day--today',
      highlighted: 'picker__day--highlighted',
      infocus: 'picker__day--infocus',
      outfocus: 'picker__day--outfocus',
      onSet: context => {
        if ('select' in context) {
          this.onDateSelected(context.select)
        } else if ('clear' in context) {
          this.onClear()
        }
      }
    }).pickadate('picker')
  },
  methods: {
    onDateSelected: function (value) {
      if (value) {
        this.$emit('input', new Date(value))
      }
    },
    onClear: function () {
      this.$emit('input', null)
    },
    openPicker: function () {
      if (this.picker) {
        this.picker.open()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/fields/DatePicker.vue